import { vars } from "@donaswap/ui/css/vars.css";
import { darkColors, lightColors, fireColors } from "../../theme/colors";
import { TooltipTheme } from "./types";

export const light: TooltipTheme = {
  background: lightColors.backgroundAlt,
  text: lightColors.text,
  boxShadow: vars.shadows.tooltip,
};

export const dark: TooltipTheme = {
  background: darkColors.backgroundAlt,
  text: darkColors.text,
  boxShadow: vars.shadows.tooltip,
};

export const fire: TooltipTheme = {
  background: fireColors.backgroundAlt,
  text: fireColors.text,
  boxShadow: vars.shadows.tooltip,
};
